import { claimApi } from '../api';
import { IClaim } from '../model/search.model';
import { IClaimDocs } from '../model/claim.model';
import { ACTION_TYPES } from './store/actions';

// récupérer la liste des dossiers selon la recherche par (email/claim|SubNumber/ first|lastName)
export const getClaimsByClient = (client: IClaim) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_CLAIMS_BY_CLIENT,
    payload: claimApi.getClaimByClient(client),
  });
};

export const getClaimsClientsForActiveSubscription = () => async dispatch => {
  let client: IClaim;
  await dispatch({
    type: ACTION_TYPES.Get_Claims_Clients_For_Active_Subscription,
    payload: claimApi.getClaimsClientsForActiveSubscription(),
  });
};

// Upload les document attachés a un sinistre dans Krys et BT
export const uploadClaimDocs = (claim: IClaimDocs) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.UPLOAD_CLAIMS,
    payload: claimApi.uploadClaimDocs(claim),
  });
};

// get Liste des sinistres avec le numeros d'adhésion dans BT
export const getclaimsListBySubscriptionNumber = (subscriptionNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER,
    payload: claimApi.getclaimsListBySubscriptionNumber(subscriptionNumber),
  });
};

// get Liste des sinistres avec le numeros d'adhésion dans BT
export const getclaimsListBySubscriptionNumberForContractDaitails = (subscriptionNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_CLAIM_LIST_BY_SUBSCRIPTION_NUMBER_FOR_CONTRACT_DETAILS,
    payload: claimApi.getclaimsListBySubscriptionNumber(subscriptionNumber),
  });
};

// Retourne un url qui fait la redirection de KRYS && BT  vers parkour
export const declarerSinistre = (subscriptionNumber: string) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.DECLARE_SINISTRE_BY_SUBSCRIPTION_NUMBER,
    payload: claimApi.declarerSinistre(subscriptionNumber),
  });
};

export const setPage = (page: number) => dispatch => {
  dispatch({
    type: ACTION_TYPES.SET_PAGE,

    payload: { page },
  });
};

export const resetCaims = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.RESET_CLAIMS,

    payload: [],
  });
};

export const resetCaimsForContract = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.RESET_CLAIMS_FOR_CONRACT,

    payload: [],
  });
};

export const emptyRedirectLink = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.EMPTY_REDIRECT_LINK,
  });
};

// ok
export const getclaim = (claimNumber: string) => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_CLAIM,
    payload: claimApi.getclaim(claimNumber),
  });
  const claim = await getState().claim?.claimModel?.claim;
  if (claim === 'NOT_ACCESS') {
    window.location.href = '/claims';
  }
};

// ok
export const getEvents = (entityType: string, number: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_CLAIM_EVENTS,
    payload: claimApi.getClaimEvent(entityType, number),
  });
};

// ok
export const getPaperAndDocument = (claimNumber: string, subscriptionNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_PAPER_AND_DOCUMENT,
    payload: claimApi.getPaperAndDocument(claimNumber, subscriptionNumber),
  });
};

// ok
export const getClaimSubscription = (subscriptionNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_CLAIM_SUBSCRIPTION,
    payload: claimApi.getClaimSubscription(subscriptionNumber),
  });
};

// ok

export const findBenefit = (claimNumber: string) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.GET_BENEFIT,
    payload: claimApi.getBenefit(claimNumber),
  });
};
